import { NbToastrService } from '@nebular/theme';
import { TipologiaStruttura, OrarioStruttura } from '@hm_app/@core/models/struttura';
import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash-es';

import {
    Struttura,
    ServizioStruttura,
    TipoServizioStruttura,
} from '@hm_app/@core/models/struttura';

import { Location } from '@angular/common';

import {
    Distretto,
    AreaVasta,
    AziendaSanitaria,
    Comune,
} from '@hm_app/@core/models/anagrafica_geo';

import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { NbRoleProvider } from '@nebular/security';
import { BaseAuthenticatedComponent } from '@hm_app/shared/base-authenticated/base-authenticated.component';

@Component({
    selector: 'app-struttura-detail',
    templateUrl: './struttura-detail.component.html',
    styleUrls: ['./struttura-detail.component.scss'],
})
export class StrutturaDetailComponent extends BaseAuthenticatedComponent implements OnInit {


    get marker_options(): google.maps.MarkerOptions {
        return { draggable: false }
    }

    get struttura_position(): google.maps.LatLngLiteral {
        return {
            lat: 43.5500346,
            lng: 10.3271613
        }
        if (!this.struttura) {
            return null;
        }
        return {
            lat: this.struttura.latitudine,
            lng: this.struttura.longitudine
        };
    }
    get map_options(): google.maps.MapOptions {
        return {
            center: this.struttura_position,
            zoom: 15
        }
    }

    distretto: Distretto;

    get mailto_dest(): string {
        return this.struttura?.contatto_email || this.struttura?.email;
    }

    get isReferente() {
        if (!this.distretto || !this.user) {
            return false;
        }
        return this.distretto.referente == this.user.id;
    }

    constructor(
        protected hmService: HappyMammaService,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider,
        private location: Location,
    ) {
        super(hmService, toastrService, roleProvider);
    }

    @Input() private _struttura: Struttura;

    servizi_strutture: ServizioStruttura[];
    orari_strutture: OrarioStruttura[];
    tipi_serv_strut: Map<number, TipoServizioStruttura> = new Map();
    distretti: Map<number, Distretto> = new Map();
    strutture: Map<number, Struttura> = new Map();
    tipologie_strutture: Map<number, TipologiaStruttura> = new Map();
    aziende_sanitarie: Map<number, AziendaSanitaria> = new Map();
    aree_vaste: Map<number, AreaVasta> = new Map();
    comuni: Map<number, Comune> = new Map();

    fetched: boolean;

    async fetchDependencies() {

        const dists = await this.hmService.distrettiAllPromise();

        dists.forEach(d => {
            this.distretti.set(d.id, d);
        });
        this.set_isReferente();

        const strutture = await this.hmService.struttureAllPromise();
        strutture.forEach(d => this.strutture.set(d.id, d));

        const tipologie = await this.hmService.tipologieStrutturaAllPromise();
        tipologie.forEach(d => this.tipologie_strutture.set(d.id, d));

        const aree_vaste = await this.hmService.areeVasteAllPromise();
        aree_vaste.forEach(d => this.aree_vaste.set(d.id, d));

        const aziende_sanitarie = await this.hmService.aziendeAllPromise();
        aziende_sanitarie.forEach(d => this.aziende_sanitarie.set(d.id, d));

        const tipi_serv_strut = await this.hmService.tipoServizioStrutturaAllPromise();
        tipi_serv_strut.forEach(d => this.tipi_serv_strut.set(d.id, d));

        const coms = await this.hmService.comuniToscanaAllPromise();
        coms.forEach(d => {
            this.comuni.set(d.id, d);
        });

        this.fetched = true;
        if (this.struttura) {
            this.fetchOrariServizi().then();
        }
    }

    async fetchOrariServizi() {
        if (!this.orari_strutture) {
            const orari = await this.hmService.getAll<OrarioStruttura>(OrarioStruttura, { struttura: this.struttura.id }).toPromise();

            if (!orari || orari.length == 0) {
                this.orari_strutture = null;
            } else {
                this.orari_strutture = orari;
            }
        }

        let servizi = await this.hmService
            .getAll<ServizioStruttura>(ServizioStruttura, {
                struttura: this.struttura.id,
            }).toPromise();

        if (servizi) {
            const ordered = _.orderBy(servizi, (s: ServizioStruttura) => {
                if (s.tipo_serv_strut == null)
                    return -1;

                if (s.tipo_serv_strut instanceof TipoServizioStruttura) {
                    return s.tipo_serv_strut.ordinamento;
                }
                const index = s.tipo_serv_strut as number;

                // console.log("tipo serv index " + index);
                // console.log(JSON.stringify(this.tipi_serv_strut));

                const tipo_serv_strut = this.tipi_serv_strut.get(index);
                if (!tipo_serv_strut) {
                    return -1;
                }
                // console.log("tipo serv " + JSON.stringify(tipo_serv_strut));

                return tipo_serv_strut.ordinamento;
            });
            servizi = ordered;
        }
        this.servizi_strutture = servizi;
    }

    get struttura(): Struttura {
        return this._struttura;
    }

    set struttura(s: Struttura) {
        this._struttura = s;
        // console.log(this._struttura);
        this.set_isReferente();
        if (this.fetched) {
            this.fetchOrariServizi().then();
        }
    }

    async ngOnInit() {
        this.servizi_strutture = null;
        await this.fetchDependencies();
    }

    set_isReferente() {
        this.distretto = this.distretti.get(this.struttura.distretto);
    }

    goBack(): void {
        this.location.back();
    }
}
